"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWriteTransactionImplementation = exports.WriteTransaction = void 0;
const index_js_1 = require("../../../entity/index.js");
class WriteTransaction extends index_js_1.EntityAction {
}
exports.WriteTransaction = WriteTransaction;
const isWriteTransactionImplementation = (input) => input instanceof WriteTransaction;
exports.isWriteTransactionImplementation = isWriteTransactionImplementation;
